import React from "react";
import LayoutOperacionesAliado from "../../components/aliadosOperaciones/LayoutOperacionesAliado";
import BuscadorCuponesAliado from "../../components/aliadosOperaciones/BuscadorCuponesAliado";

const BuscadorCuponesInternoAliado = () => (
  <LayoutOperacionesAliado title="Buscador de cupones">
    <BuscadorCuponesAliado />
  </LayoutOperacionesAliado>
);

export default BuscadorCuponesInternoAliado;
